"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = containerChecker;
function containerChecker(node, params) {
  var _ref = params || {},
    _ref$isNotification = _ref.isNotification,
    isNotification = _ref$isNotification === void 0 ? false : _ref$isNotification;
  var targetElement = document.body;
  try {
    if (!isNotification) {
      if (node && typeof node.getRootNode === 'function' && node.getRootNode() instanceof ShadowRoot) {
        // sparx modules
        targetElement = node.getRootNode();
        if (targetElement.querySelector('.sparx-app-container')) {
          // sparx process
          targetElement = targetElement.querySelector('.sparx-app-container');
        } else if (targetElement.querySelector('.sparx-footer-container')) {
          // harmonipagefooter && harmonifixedfooter
          targetElement = document.querySelector('#page-tabs .tab-pane.active sparx-process').shadowRoot.querySelector('.sparx-app-container');
        }
      } else {
        targetElement = document.querySelector('#page-tabs .tab-pane.active sparx-process').shadowRoot.querySelector('.sparx-app-container');
      }
    }
  } catch (error) {
    // console.log('containerChecker:', error);
  }
  return targetElement;
}